import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import TournamentsPage from './pages/TournamentsPage';
import LessonsAndProgramsPage from './pages/LessonsAndProgramsPage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <div className="site-shell">
      <div className="page-glow page-glow-left" />
      <div className="page-glow page-glow-right" />
      <Navbar />

      <main className="page-frame">
        <Routes>
          <Route path="/" element={<TournamentsPage />} />
          <Route path="/tournaments" element={<TournamentsPage />} />
          <Route path="/lessons-and-programs" element={<LessonsAndProgramsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <footer className="site-footer">© Bahamas Chess Institute, 2026. All rights reserved.</footer>
    </div>
  );
}

export default App;
